export const CAJUSPLogo = ({ variant = "light", compact = false, className = "" }) => {
    const main = variant === "light" ? "#F5F1EA" : "#1C2025";
    const sub = variant === "light" ? "#9EA8B6" : "#5A626C";
    return (
        <svg
            viewBox={compact ? "0 0 340 84" : "0 0 340 104"}
            className={className}
            role="img"
            aria-label="CAJUSP — Câmara de Juízo Arbitral e Mediação Empresarial de São Paulo"
        >
            <text
                x="170"
                y={compact ? 38 : 40}
                textAnchor="middle"
                fill={main}
                style={{
                    fontFamily: "'Cormorant Garamond', Georgia, serif",
                    fontSize: 40,
                    fontWeight: 600,
                    letterSpacing: 8,
                }}
            >
                CAJUSP
            </text>
            <path
                d="M54 52 Q 170 22 286 50"
                fill="none"
                stroke="#B08D4C"
                strokeWidth="2.4"
                strokeLinecap="round"
            />
            {!compact && (
                <>
                    <line x1="16" y1="68" x2="50" y2="68" stroke="#B08D4C" strokeWidth="1" />
                    <line x1="290" y1="68" x2="324" y2="68" stroke="#B08D4C" strokeWidth="1" />
                    <text
                        x="170"
                        y="72"
                        textAnchor="middle"
                        fill={main}
                        style={{
                            fontFamily: "'Cormorant Garamond', Georgia, serif",
                            fontSize: 9,
                            fontWeight: 500,
                            letterSpacing: 2.8,
                        }}
                    >
                        CÂMARA DE JUÍZO ARBITRAL
                    </text>
                    <text
                        x="170"
                        y="84"
                        textAnchor="middle"
                        fill={main}
                        style={{
                            fontFamily: "'Cormorant Garamond', Georgia, serif",
                            fontSize: 9,
                            fontWeight: 500,
                            letterSpacing: 2.8,
                        }}
                    >
                        E MEDIAÇÃO EMPRESARIAL
                    </text>
                    <text
                        x="170"
                        y="97"
                        textAnchor="middle"
                        fill={sub}
                        style={{
                            fontFamily: "'Cormorant Garamond', Georgia, serif",
                            fontSize: 8.5,
                            letterSpacing: 4,
                        }}
                    >
                        DE SÃO PAULO
                    </text>
                </>
            )}
        </svg>
    );
};
